import {getToken} from "../helpers/token";

export const verifyCustomerEmail = (uuId, code) => {
	return fetch(`/api/application/${uuId}/verify-customer-email`, {
		method: 'POST',
		headers: {
			'Cache-Control': 'no-cache',
			'content-type': 'application/json',
			'Authorization': `Bearer ${getToken()}`
		},
		body: JSON.stringify({code: code}),
	});
}

export const updateCustomerEmail = (uuId, email) => {
	return fetch(`/api/application/${uuId}/update-customer-email`, {
		method: 'POST',
		headers: {
			'Cache-Control': 'no-cache',
			'content-type': 'application/json',
			'Authorization': `Bearer ${getToken()}`
		},
		body: JSON.stringify({email}),
	});
}

export const sendCustomerEmailVerificationCode = (uuId) => {
	return fetch(`/api/application/${uuId}/send-customer-email-verification-code`, {
		method: 'POST',
		headers: {
			'Cache-Control': 'no-cache',
			'content-type': 'application/json',
			'Authorization': `Bearer ${getToken()}`
		},
	});
}
